import React, { useState, useRef, useEffect } from 'react';
import { X, Plus, Filter } from 'lucide-react';
import { useTask } from '../../contexts/TaskContext';
import TaskCard from './TaskCard';

const TaskMenu = ({ onClose, onNewTask }) => {
  const { assignedToMe, assignedByMe, loading, openTaskDetail } = useTask();
  const [activeTab, setActiveTab] = useState('assignedToMe');
  const [statusFilter, setStatusFilter] = useState('pending');
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  const getFilteredTasks = () => {
    const taskList = activeTab === 'assignedToMe' ? assignedToMe : assignedByMe;
    
    if (statusFilter === 'all') {
      return taskList;
    }
    
    return taskList.filter(task => task.status === statusFilter);
  };

  const filteredTasks = getFilteredTasks();

  return (
    <>
      <div
        ref={containerRef}
        className="fixed sm:absolute right-2 sm:right-0 top-16 sm:top-auto sm:mt-2 w-[calc(100vw-1rem)] sm:w-80 md:w-96 max-w-[calc(100vw-1rem)] sm:max-w-none bg-white dark:bg-gray-800 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-700 z-50 max-h-[80vh] flex flex-col"
      >
        <div className="px-4 py-3 border-b border-gray-200 dark:border-gray-700 sticky top-0 bg-white dark:bg-gray-800 rounded-t-2xl flex items-center justify-between">
          <div>
            <p className="text-sm font-semibold text-gray-900 dark:text-white">Görevler</p>
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
              {filteredTasks.length} görev
            </p>
          </div>
          <button
            onClick={onClose}
            className="p-1 rounded-lg text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        {/* Tabs */}
        <div className="flex border-b border-gray-200 dark:border-gray-700">
          <button
            onClick={() => setActiveTab('assignedToMe')}
            className={`flex-1 px-4 py-2 text-sm font-medium transition-colors ${
              activeTab === 'assignedToMe'
                ? 'text-blue-600 dark:text-blue-400 border-b-2 border-blue-600 dark:border-blue-400'
                : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
            }`}
          >
            Bana Atanan ({assignedToMe.length})
          </button>
          <button
            onClick={() => setActiveTab('assignedByMe')}
            className={`flex-1 px-4 py-2 text-sm font-medium transition-colors ${
              activeTab === 'assignedByMe'
                ? 'text-blue-600 dark:text-blue-400 border-b-2 border-blue-600 dark:border-blue-400'
                : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
            }`}
          >
            Benim Atadığım ({assignedByMe.length})
          </button>
        </div>

        {/* Filter */}
        <div className="px-4 py-2 border-b border-gray-200 dark:border-gray-700 flex items-center gap-2">
          <Filter className="w-4 h-4 text-gray-400" />
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="flex-1 text-sm bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg px-3 py-1.5 text-gray-900 dark:text-white"
          >
            <option value="all">Tümü</option>
            <option value="pending">Beklemede</option>
            <option value="in_progress">Devam Ediyor</option>
            <option value="completed">Tamamlandı</option>
            <option value="cancelled">İptal Edildi</option>
          </select>
        </div>

        {/* Task List */}
        <div className="flex-1 overflow-y-auto p-2">
          {loading ? (
            <div className="flex items-center justify-center py-8">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            </div>
          ) : filteredTasks.length === 0 ? (
            <div className="text-center py-8 text-gray-500 dark:text-gray-400">
              <p className="text-sm">Görev bulunamadı</p>
            </div>
          ) : (
            <div className="space-y-2">
              {filteredTasks.map((task) => (
                <TaskCard
                  key={task.id}
                  task={task}
                  onClick={() => {
                    onClose(); // TaskMenu'yu kapat
                    openTaskDetail(task.id);
                  }}
                />
              ))}
            </div>
          )}
        </div>

        {/* New Task Button */}
        <div className="px-4 py-3 border-t border-gray-200 dark:border-gray-700">
          <button
            onClick={() => {
              onClose();
              onNewTask();
            }}
            className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-medium transition-colors"
          >
            <Plus className="w-4 h-4" />
            Yeni Görev Ata
          </button>
        </div>
      </div>
    </>
  );
};

export default TaskMenu;

